import ModelUtil from '@leverege/model-util'
// eslint-disable-next-line import/no-cycle
import {
  getIsOpen,
  getIsOverride,
  getMatchingDayName,
  getTimeUntilOpen,
  getTimeSinceClose,
  getTimeUntilClose,
  getNextCloseTimestamp,
  getLastOpenTimestamp,
  getResult,
  getTimeSinceOpen,
  getNextOpenTimestamp,
  getLastCloseTimestamp,
  getHoursForDate
} from './OperatingHoursCalcUtil.js'

const TYPE = 'imagine.operatingHours'

// const TEMP_CLOSED = () => WeeklyHours.create( {
//   name : 'Temporarily Closed',
//   monday : DailyHours.create( { open : false, name : 'Monday' } ),
//   tuesday : DailyHours.create( { open : false, name : 'Tuesday' } ),
//   wednesday : DailyHours.create( { open : false, name : 'Wednesday' } ),
//   thursday : DailyHours.create( { open : false, name : 'Thursday' } ),
//   friday : DailyHours.create( { open : false, name : 'Friday' } ),
//   saturday : DailyHours.create( { open : false, name : 'Saturday' } ),
//   sunday : DailyHours.create( { open : false, name : 'Sunday' } )
// } )

function create( options ) {
  const opts = options || {}

  return {
    type : TYPE,
    currentMode : opts.currentMode || null,
    timezone : opts.timezone || 'America/New_York',
    modes : opts.modes || null,
    overrides : opts.overrides || null
  }
}

export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'currentMode' ),
  ...ModelUtil.createAllValue( 'timezone' ),
  ...ModelUtil.createAllMap( 'modes' ),
  ...ModelUtil.createAllMap( 'overrides' ),
  getIsOpen,
  getMatchingDayName,
  getIsOverride,
  getTimeUntilOpen,
  getTimeSinceClose,
  getTimeUntilClose,
  getNextCloseTimestamp,
  getTimeSinceOpen,
  getLastOpenTimestamp,
  getResult,
  getNextOpenTimestamp,
  getLastCloseTimestamp,
  getHoursForDate
}
